import SearchCupsInput from './SearchCupsInput';

export default SearchCupsInput;
